import { requestService } from '../helpers/request.service';

export const nomService = {
    getRiskType: cacheCalls(getRiskType, 'getRiskType'),
    getWpNomFormularById,
    getLogin,
    setPartner,
    postContact,
    getPatientbyCNP,
    getSubscriptions,
    getConsultation,
    getPreauthorization,
    getSpecialContracts,
    getPreauthorizationMM,
    getMMRecords,
    getTemporaryAlocation,
    getSpecialities,
    getDoctorsType,
    getDiagnostics: cacheCalls(getDiagnostics, 'getDiagnostics'),
    getDiagnosticsById,
    getInvestigations,
    getInvestigationsById,
    getRrecordsType,
    getCorFunctions,
    getProfessionsByContract,
    getMMResolutions: cacheCalls(getMMResolutions, 'getMMResolutions'),
    getMwRecomandations: cacheCalls(getMwRecomandations, 'getMwRecomandations'), 
    getNoxes,
    getForms,
    getFileTypes,
    getMMRecordStatus,
    getCounties,
    getFinancialStatus,
    isCNPAdded,
    getRole
};

const cache = new Map();


function cacheCalls(func, cacheKey) {
    return function (params) {
        if (!params) {
            const cachedResult = cache.get(cacheKey);
            if (cachedResult) {
                return Promise.resolve(cachedResult);
            }
        }
        return func(params).then(result => {
            if (!params) {
                cache.set(cacheKey, result);
            }
            return result;
        });
    };
}


function getRiskType() {
    return cache.get('getRiskType') || requestService.get({
        methodName: '/Nom/RiskType'
    });
}

function getCounties() {
    return requestService.get({
        methodName: '/Nom/GetCounties'
    });
}


function getWpNomFormularById(params) {
    return requestService.get({
        methodName: '/Nom/GetWpNomFormularById',
        queryString: params
    });
}

function getSpecialContracts(params) {
    return requestService.get({
        methodName: '/Nom/GetSpecialContracts',
        queryString: params
    });
}


function getLogin(params) {
    return requestService.post({
        methodName: '/Authentification/Login',
        body: params
    });
}


function setPartner(params) {
    return requestService.post({
        methodName: '/Authentification/SetPartner',
        body: params
    });
}



function postContact(params) {
    return requestService.post({
        methodName: '/Contact',
        body: params
    });
}

function getPatientbyCNP(params) {
    return requestService.get({
        methodName: '/Patient/GetPatientByCNP',
        queryString: params
    });
}

function getSubscriptions(params) {
    return requestService.get({
        methodName: '/Patient/GetSubscriptionsByCode',
        queryString: params
    });
}

function getConsultation(params) {
    return requestService.get({
        methodName: '/Patient/GetConsultationsByCode',
        queryString: params
    });
}

function getPreauthorization(params) {
    return requestService.get({
        methodName: '/Patient/GetPreauthorizationByCode',
        queryString: params
    });
}

function getPreauthorizationMM(params) {
    return requestService.get({
        methodName: '/Patient/GetMMPreauthorizationByCode',
        queryString: params
    });
}

function getMMRecords(params) {
    return requestService.get({
        methodName: '/Patient/GetMMRecordsByCode',
        queryString: params
    });
}

function getTemporaryAlocation(params) {
    return requestService.get({
        methodName: '/Patient/GetTemporaryAlocation',
        queryString: params
    });
}

function getSpecialities(params) {
    return requestService.get({
        methodName: '/Nom/GetSpecialities',
        queryString: params
    });
}

function getDoctorsType(params) {
    return requestService.get({
        methodName: '/Nom/GetDoctorsType',
        queryString: params
    });
}


function getDiagnostics() {
    return cache.get('getDiagnostics') || requestService.get({
        methodName: '/Nom/GetDiagnostics'
    });
}

function getDiagnosticsById(params) {
    return requestService.get({
        methodName: '/Nom/GetDiagnosticsById',
        queryString: params
    });
}


function getInvestigations(params) {
    return requestService.get({
        methodName: '/Nom/GetInvestigations',
        queryString: params
    });
}

function getInvestigationsById(params) {
    return requestService.get({
        methodName: '/Nom/GetInvestigationsById',
        queryString: params
    });
}


function getRrecordsType(params) {
    return requestService.get({
        methodName: '/Nom/GetRecordsType',
        queryString: params
    });
}

function getCorFunctions(params) {
    return requestService.get({
        methodName: '/Nom/GetCorFunctions',
        queryString: params
    });
}

function getProfessionsByContract(params) {
    return requestService.get({
        methodName: '/Nom/GetProfessionsByContract',
        queryString: params
    });
}

function getMMResolutions(params) {
    return requestService.get({
        methodName: '/Nom/GetMMResolutions',
        queryString: params
    });
}

function getMwRecomandations(params) {
    return requestService.get({
        methodName: '/Nom/GetMwRecomandations',
        queryString: params
    });
}


function getNoxes(params) {
    return requestService.get({
        methodName: '/Nom/GetNoxes',
        queryString: params
    });
}


function getForms(params) {
    return requestService.get({
        methodName: '/Nom/GetForms',
        queryString: params
    });
}

function getFileTypes(params) {
    return requestService.get({
        methodName: '/Nom/FileTypes',
        queryString: params
    });
}

function getMMRecordStatus(params) {
    return requestService.get({
        methodName: '/Nom/GetMMRecordStatus',
        queryString: params
    });
}

function getFinancialStatus(params) {
    return requestService.get({
        methodName: '/Nom/FinancialStatus',
        queryString: params
    });
}

function isCNPAdded(params) {
    return requestService.get({
        methodName: '/Patient/IsCNPAdded',
        queryString: params
    });
}

function getRole() {
    return requestService.get({
        methodName: '/Nom/GetRole'
    });
}
